export type NavigationItem = {
    label: string;
    path: string;
    icon?: string;
    children?: NavigationItem[];
};

export const primaryNavigation: NavigationItem[] = [
    {
        label: "Dashboard",
        path: "/"
    },
    {
        label: "Users",
        path: "/users"
    },
    {
        label: "Riders",
        path: "/riders"
    },
    {
        label: "Drivers",
        path: "/drivers"
    },
    {
        label: "Ride Bookings & Trips",
        path: "/ride-bookings-trips"
    },
    {
        label: "Wallet & Payments",
        path: "/wallet-payments"
    },
    // {
    //     label: "Fraud & Safety",
    //     path: "/fraud-safety"
    // },
    // {
    //     label: "Live Monitoring",
    //     path: "/live-monitoring"
    // },
    {
        label: "Notifications & Messaging",
        path: "/notifications"
    },
    {
        label: "Approval Queue",
        path: "/approval-queue"
    },
    {
        label: "Admin Management",
        path: "/admin-management"
    },
    {
        label: "Platform Configuration",
        path: "/platform-configuration"
    },
    {
        label: "Reports & Analytics",
        path: "/reports-analytics"
    },
    {
        label: "Audit & Logs",
        path: "/audit-logs"
    },
    {
        label: "Settings",
        path: "/settings"
    }
];
